var map = {
	"./logo_ayar.png": 9420,
	"./logo_bling.png": 9005,
	"./logo_cata.png": 7774,
	"./logo_chato.png": 9402,
	"./logo_dada.png": 1227,
	"./logo_dico.png": 4784,
	"./logo_elive.png": 4652,
	"./logo_fuga.png": 7596,
	"./logo_gela.png": 9198,
	"./logo_haii.png": 9660,
	"./logo_mako.png": 8559,
	"./logo_meegolive.png": 9804,
	"./logo_pinka.png": 1742,
	"./logo_poca.png": 7272,
	"./logo_tenderu.png": 9348,
	"./logo_tigo.png": 3180,
	"./logo_tilive.png": 5780,
	"./logo_toki.png": 8972,
	"./logo_welive.png": 8901,
	"./logo_yahlive.png": 3035
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6880;